import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './documentoViagemForm';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import ReactExport from 'react-export-excel-fixed-xlsx';
import InputPesquisa from '../common/form/inputPesquisa';

import {
	setModoTela, setFiltroFinalizada as setFiltro, initForm, salvar, excluir, getListaFinalizada as getLista, setFinalizada,
	setModoTelaComprovante, initFormComprovante, salvarComprovante, excluirComprovante, getListaComprovante, getListaHistorico,
	getListaOcorrencia, setModoTelaOcorrencia, getListaPalete, getListaPaleteStatus,
	getListaOperacao, getListaDocumento, getListaStatus } from './documentoViagemActions';
import { getLista as getListaCliente } from '../cliente/clienteActions';
import ColorUtils from '../common/colorUtils/ColorUtils';

class DocumentoViagemFinalizada extends Component {

	state = {
		pesquisar: '',
		pesquisarAux: '',
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaOperacao();
		this.props.getListaDocumento();
		this.props.getListaStatus();
		this.props.getListaPaleteStatus();
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={() => {}} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let alterar = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_comprovante_finalizada_alterar;
		let desfazer = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_comprovante_finalizada_desfazer;
			

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



		let lista = this.props.lista
		//FILTRO BUSCA TEXTO
		.filter(item => {
			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
					if (pesquisar
						&& !(`
								${item.solicitacao || ''} ${item.romaneio || ''} ${DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem)} ${DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga)}
				${item.tipo_documento || ''} ${item.numero_documento || ''} ${item.mic_documento || ''} ${item.shipping || ''} ${item.cavalo || ''} ${item.nome_motorista || ''}
				${item.nome_cliente || ''} ${item.nome_recebedor || ''} ${item.cidade_coleta || ''} ${item.estado_coleta || ''} ${item.pais_coleta || ''} ${item.cidade_entrega || ''}
				${item.estado_entrega || ''} ${item.pais_entrega || ''} ${item.nome_operacao || ''} ${item.nome_perfil || ''} || ${item.tipo_veiculo || ''}
							`).toUpperCase().includes(pesquisar)) {
						return false;
					}

					return true;

				}).length > 0;
		}).filter(item => {

			//Filtra a operação do cadastro do usuário
			if (this.props.usuarioCarregado && (this.props.usuarioCarregado.id_operacoes || []).length > 0
				&& !this.props.usuarioCarregado.id_operacoes.includes(parseInt(item.codigo_operacao))) {
				return false;
			}

			if ((this.props.filtro.anexos == 2 && item.qtd_digital_selecionado <= 0) 
				|| (this.props.filtro.anexos == 3 && item.qtd_digital_selecionado > 0)) {
				return false;
			}

			if ((this.props.filtro.faturado == 2 && !item.faturado) 
				|| (this.props.filtro.faturado == 3 && item.faturado)) {
				return false;
			}

			if ((this.props.filtro.status_ocorrencia == 2 && !item.ocorrencia_aberta)
				|| (this.props.filtro.status_ocorrencia == 3 && (item.ocorrencia_aberta || !item.ocorrencia_finalizada))
				|| (this.props.filtro.status_ocorrencia == 4 && (item.ocorrencia_aberta || item.ocorrencia_finalizada))
			) {
				return false;
			}

			return true;

		}).filter(item => {

			let retorno = false;
			switch (String(this.props.filtro.id_status_comprovante)) {
				case '1': //Todos
					retorno = true;
					break;
				
				case '2': //Aguardando Original
					retorno = item.aguardando_original;
					break;
					
				case '3': //Aguardando Digital
					retorno = item.aguardando_digital;
					break;
					
				case '4': //Aguardando Original ou Digital
					retorno = item.aguardando_original || item.aguardando_digital;
					break;
					
				case '5': //Aguardando Original e Digital
					retorno = item.aguardando_original && item.aguardando_digital;
					break;
					
				case '6': //Aguardando Financeiro
					retorno = item.aguardando_financeiro;
					break;
					
				case '7': //Paletes em Aberto
					retorno = this.props.listaPaleteStatus.filter(itemPalete => itemPalete.solicitacao == item.solicitacao && itemPalete.aberta).length > 0;
					break;
					
				case '8': //Paletes Finalizados
					retorno = this.props.listaPaleteStatus.filter(itemPalete => itemPalete.solicitacao == item.solicitacao && !itemPalete.aberta).length > 0
					break;
			
				default:
					retorno = true;
					break;
			}

			return retorno;

		});
		
		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							minWidth={343}
							cols='12 12 2 2'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<LabelAndInputMask
							label='Data Inicial' placeholder='Informe'
							cols='12 6 3 2'
							mask='99/99/9999'
							minWidth={130}
							maxWidth={130}
							value={this.props.filtro.data_inicial}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							label='Data Final' placeholder='Informe'
							cols='12 6 3 2'
							mask='99/99/9999'
							minWidth={130}
							maxWidth={130}
							value={this.props.filtro.data_final}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />

						<Select
							options={[{ id: 'periodo_carga', valor: 'Carga' }, { id: 'periodo_descarga', valor: 'Descarga' }, { id: 'periodo_finalizacao', valor: 'Finalização' }]}
							label='Período'
							cols='12 3 3 3'
							maxWidth={180}
							placeholder='Selecione o período'
							value={this.props.filtro.periodo}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, periodo: data });
							}} />

						<Select
							options={this.props.listaOperacao}
							label='Operação'
							cols='12 3 3 3'
							maxWidth={250}
							placeholder='Selecione a operação'
							value={this.props.filtro.id_operacao}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, id_operacao: data });
							}} />

						<Select
							options={this.props.listaStatusComprovante}
							label='Status'
							cols='12 3 3 3'
							placeholder='Selecione o status'
							maxWidth={250}
							value={this.props.filtro.id_status_comprovante}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, id_status_comprovante: data });
							}} />

						<Select
							options={[{ id: 1, valor: 'Todos' }, { id: 2, valor: 'Apenas com anexo' }, { id: 3, valor: 'Apenas sem anexo' }]}
							label='Anexos'
							cols='12 3 3 3 '
							placeholder='Selecione'
							maxWidth={250}
							value={this.props.filtro.anexos}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, anexos: data });
							}} />

						<Select
							options={[{ id: 1, valor: 'Todos' }, { id: 2, valor: 'Apenas faturados' }, { id: 3, valor: 'Apenas não faturados' }]}
							label='Faturado'
							cols='12 3 3 3 '
							maxWidth={250}
							placeholder='Selecione'
							value={this.props.filtro.faturado}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, faturado: data });
							}} />

						<Select
							options={[{ id: 1, valor: 'Todas' }, { id: 2, valor: 'Ocorrência aberta' }, { id: 3, valor: 'Ocorrência finalizada' }, { id: 4, valor: 'Sem ocorrência' }]}
							label='Ocorrência'
							cols='12 3 3 3 '
							maxWidth={250}
							placeholder='Selecione'
							value={this.props.filtro.status_ocorrencia}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, status_ocorrencia: data });
							}} />

						<div style={{ paddingTop: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaPaleteStatus();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<ExcelFile
								filename={'Viagens Comprovação'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
									datahora_descarga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga),
									datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
									local_coleta: `${item.cidade_coleta} - ${item.estado_coleta} - ${item.pais_coleta}`,
									local_entrega: `${item.cidade_entrega} - ${item.estado_entrega} - ${item.pais_entrega}`,
									ocorrencia_aberta: item.ocorrencia_aberta ? 'SIM' : 'NÃO'
								}))} name='Viagens Comprovação'>
									<ExcelColumn label='Sol.' value='solicitacao' />
									<ExcelColumn label='Rom.' value='romaneio' />
									<ExcelColumn label='Emissão' value='datahora_viagem' />
									<ExcelColumn label='Descarga' value='datahora_descarga' />
									<ExcelColumn label='Tipo Doc' value='tipo_documento' />
									<ExcelColumn label='Documento' value='numero_documento' />
									<ExcelColumn label='MIC' value='mic_documento' />
									<ExcelColumn label='Shipping' value='shipping' />
									<ExcelColumn label='Veículo' value='cavalo' />
									<ExcelColumn label='Motorista Entrega' value='nome_motorista' />
									<ExcelColumn label='Tipo' value='tipo_veiculo' />
									<ExcelColumn label='Cliente' value='nome_cliente' />
									<ExcelColumn label='Recebedor' value='nome_recebedor' />
									<ExcelColumn label='Local Coleta' value='local_coleta' />
									<ExcelColumn label='Local Entrega' value='local_entrega' />
									<ExcelColumn label='Operação' value='nome_operacao' />
									<ExcelColumn label='Perfil' value='nome_perfil' />
									<ExcelColumn label='Ocorrência Aberta' value='ocorrencia_aberta' />
									<ExcelColumn label='Tipo da Ocorrência' value='nome_tipo_ocorrencia_aberta' />
								</ExcelSheet>
							</ExcelFile>
						</div>
					</Row>

					<Table responsive tableBordered>
						<THead>
							<Tr>
								<Th alignCenter width={70}></Th>
								<Th alignCenter width={80}></Th>
								<Th alignCenter width={10}>Sol.</Th>
								<Th alignCenter width={10}>Rom.</Th>
								<Th alignCenter width={100}>Emissão</Th>
								<Th alignCenter width={100}>Descarga</Th>
								<Th alignCenter width={100}>Finalização</Th>
								<Th alignCenter width={10}>Tipo Doc</Th>
								<Th alignCenter width={10}>Documento</Th>
								<Th alignCenter width={10}>MIC</Th>
								<Th alignCenter width={10}>Shipping</Th>
								<Th alignCenter width={10}>Veículo</Th>
								<Th alignCenter width={100}>Motorista Entrega</Th>
								<Th alignCenter width={10}>Tipo</Th>
								<Th alignCenter width={100}>Cliente</Th>
								<Th alignCenter width={100}>Recebedor</Th>
								<Th alignCenter width={100}>Local Coleta</Th>
								<Th alignCenter width={100}>Local Entrega</Th>
								<Th alignCenter width={100}>Operação</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter minWidth={70}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true || this.state.linhaSelecionada == item.id}
											title='Visualizar'
											small
											event={() => {
												this.props.setModoTela('visualizacao', {
													...item,
													datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
													datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
													datahora_comprovada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_comprovada),
													datahora_carga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga),
													datahora_descarga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga)
												});
												this.props.initForm({
													...item,
													datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem),
													datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao),
													datahora_comprovada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_comprovada),
													datahora_carga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga),
													datahora_descarga: DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga)
												});
												this.props.getListaHistorico(item.id);
												this.props.getListaComprovante(item.id);
												this.props.setModoTelaComprovante('lista');
												this.props.getListaOcorrencia(item.id);
												this.props.getListaPalete(item.solicitacao);
												this.props.setModoTelaOcorrencia('lista');
											}} />

										{desfazer ? (
											<ButtonTable
												type={'success'}
												icon={`fas fa-undo`}
												visible={true || this.state.linhaSelecionada == item.id}
												title={'Reabrir viagem'}
												small
												event={() => {
													this.props.setFinalizada(item, false);
												}} />
										) : null}
									</Td>
									<Td alignCenter minWidth={80}>
										{item.ocorrencia_aberta ? (
											<i class='fas fa-times-circle' style={{ color: '#ed0707', fontSize: 16, paddingTop: 4, paddingLeft: 4 }} 
												title={`Existe ocorrência aberta`}>
											</i>
										) : (item.ocorrencia_finalizada ? (
											<i class='fas fa-times-circle' style={{ color: '#a1a1a1', fontSize: 16, paddingTop: 4, paddingLeft: 4 }} 
												title={`Existe ocorrência finalizada`}>
											</i>
										) : null)}
										{item.excecao &&
										<i class='fas fa-exclamation-circle' style={{ color: '#c49b04', fontSize: 16, paddingTop: 4, paddingLeft: 4 }}
											title={item.excecao ? `Exceção: ${item.excecao}` : ''}>
										</i>}
										{item.qtd_digital_selecionado > 0 &&
										<i class='fas fa-paperclip' style={{ marginLeft: 4, paddingTop: 4, fontSize: 16 }} title={'Digital anexado'} />}
										{item.faturado &&
										<i class='fas fa-dollar-sign' style={{ marginLeft: 4, paddingTop: 4, fontSize: 16 }} title={'Documento faturado'} />}
										
										{(item.alerta_observacao && item.alerta_observacao == 'ABERTA') &&
										<i class='fas fa-comment-dots' style={{ marginLeft: 4, paddingTop: 4, fontSize: 16, color: '#c49b04' }} 
											title={
												(item.title_observacoes || []).filter(obs => obs).map((obs, i) => (
													`\nObservação ${i+1}:`
													+ `\n${obs}`
												)).join('\n')
											} />}

										{(item.alerta_observacao && item.alerta_observacao == 'FINALIZADA') &&
										<i class='fas fa-comment-dots' style={{ marginLeft: 4, paddingTop: 4, fontSize: 16, color: '#a1a1a1' }} 
											title={
												(item.title_observacoes || []).filter(obs => obs).map((obs, i) => (
													`\nObservação ${i+1}:`
													+ `\n${obs}`
												)).join('\n')
											} />}
									</Td>
									<Td alignCenter small>{item.solicitacao}</Td>
									<Td alignCenter small>{item.romaneio}</Td>
									<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_viagem)}</Td>
									<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga)}</Td>
									<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_finalizacao)}</Td>
									<Td alignCenter small>{item.tipo_documento}</Td>
									<Td alignCenter minWidth={20} small>
										{item.numero_documento}
									</Td>
									<Td alignCenter small>{item.mic_documento}</Td>
									<Td alignCenter small>{item.shipping}</Td>
									<Td alignCenter small>{item.cavalo}</Td>
									<Td alignCenter noWrap small>{item.nome_motorista}</Td>
									<Td alignCenter noWrap small>{item.tipo_veiculo}</Td>
									<Td alignCenter noWrap small>{item.nome_cliente}</Td>
									<Td alignCenter noWrap small>{item.nome_recebedor}</Td>
									<Td alignCenter noWrap small>{item.cidade_coleta} - {item.estado_coleta} - {item.pais_coleta}</Td>
									<Td alignCenter noWrap small>{item.cidade_entrega} - {item.estado_entrega} - {item.pais_entrega}</Td>
									<Td alignCenter minWidth={100} noWrap small backgroundColor={item.cor_perfil} color={ColorUtils.getCorFonte(item.cor_perfil)}>{`${item.nome_operacao }${item.nome_perfil ? ' - ' : ''}${item.nome_perfil || ''}`}</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.documentoViagem.aguardando,
	modoTela: state.documentoViagem.modoTela,
	filtro: state.documentoViagem.filtroFinalizada,
	lista: state.documentoViagem.listaFinalizada,
	listaComprovante: state.documentoViagem.listaComprovante,
	listaOperacao: state.documentoViagem.listaOperacao,
	listaDocumento: state.documentoViagem.listaDocumento,
	listaStatus: state.documentoViagem.listaStatus,
	listaStatusComprovante: state.documentoViagem.listaStatusComprovante,
	listaPaleteStatus: state.documentoViagem.listaPaleteStatus
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, setFinalizada,
	setModoTelaComprovante, initFormComprovante, salvarComprovante, excluirComprovante, getListaComprovante, getListaHistorico, getListaOcorrencia, setModoTelaOcorrencia, getListaPalete,
	getListaOperacao, getListaDocumento, getListaStatus, getListaPaleteStatus
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DocumentoViagemFinalizada);
